export const currencies = [
	{ 'code': 'EUR' },
	{ 'code': 'GBP' },
	{ 'code': 'USD' },
];
